import React, { MouseEventHandler, FunctionComponent } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { CreateTabs } from 'common/chrome/left-nav/create-tabs/CreateTabs';
import { NavTabs } from 'common/chrome/left-nav/nav-tabs/NavTabs';
import { NavToggle } from 'common/chrome/left-nav/nav-toggle/NavToggle';

import 'common/chrome/left-nav/LeftNav.scss';

interface Props {
    className?: string;
    isNavOpen: boolean;
    onNavToggle: MouseEventHandler;
}

export const LeftNav: FunctionComponent<Props> = ({ className, isNavOpen, onNavToggle }) => {
    const { t } = useTranslation('common/chrome');

    return (
        <div
            role="navigation"
            aria-label={t('LEFT_NAV_BAR')}
            className={classnames('r4e-left-nav', className, {
                'left-nav-state-open': isNavOpen,
                'left-nav-state-closed': !isNavOpen,
            })}
        >
            <NavToggle isNavOpen={isNavOpen} onNavToggle={onNavToggle} />
            <CreateTabs isNavOpen={isNavOpen} />
            <NavTabs isNavOpen={isNavOpen} />
        </div>
    );
};
